import type { ServicioResponse } from '@aid/shared';

export type ServiciosGroupBy = 'none' | 'cliente' | 'estado';

export type ServiciosGrupo = [label: string, filas: ServicioResponse[]];

function labelFor(row: ServicioResponse, groupBy: Exclude<ServiciosGroupBy, 'none'>): string {
  if (groupBy === 'cliente') {
    return row.cliente?.nombre ?? `#${row.idCliente}`;
  }
  return row.estado
    ? (row.estado.value ?? row.estado.key ?? `#${row.estado.id}`)
    : row.idEstado
      ? `#${row.idEstado}`
      : '—';
}

export function groupServicios(
  rows: ServicioResponse[],
  groupBy: ServiciosGroupBy,
): ServiciosGrupo[] | null {
  if (groupBy === 'none') return null;

  const grupos = rows.reduce((map, row) => {
    const label = labelFor(row, groupBy);
    const grupo = map.get(label);
    if (grupo) grupo.push(row);
    else map.set(label, [row]);
    return map;
  }, new Map<string, ServicioResponse[]>());

  return Array.from(grupos.entries()).sort(([a], [b]) => a.localeCompare(b, 'es'));
}
